import { connect } from 'react-redux';
import FanExpoHQFooterTitle from '../FanExpoHQFooterTitle/FanExpoHQFooterTitle';
import './FanExpoHQFooterCalendar.scss';
import { TenantDomainId } from '../../../../../../store/features/pageConfig';

const calendar = {
  title: 'Event Calendar',
  list: [
    {
      name: '2026 Christmas Show',
      date: 'Nov 27 to Dec 6 2026',
    },
    {
      name: '2027 Spring Market',
      date: 'Apr 1 to Apr 4 2027',
    },
  ],
};

export function FanExpoHQFooterCalendar(props) {
  const {
    pageConfig: { tenantId },
  } = props;

  if (tenantId !== TenantDomainId.ONEOFAKINDSHOW) return null;

  const { title, list = [] } = calendar;

  return (
    <div className="c-fan-expo-hq-footer-calendar">
      <FanExpoHQFooterTitle title={title} />
      {list.length > 0 && (
        <ul>
          {list.map((calendar) => {
            return (
              <li
                className="c-fan-expo-hq-footer-calendar__item"
                key={calendar.name}
              >
                <span className="c-fan-expo-hq-footer-calendar__item-name">
                  {calendar.name}
                </span>
                <span>{calendar.date}</span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    pageConfig: state.pageConfig,
  };
}

export default connect(mapStateToProps)(FanExpoHQFooterCalendar);
